import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { notification } from "antd";
import axios from "axios";

import BarraAreaAlunoRelatorio from "../../components/BaraAreaAlunoRelatorio/BaraAreaAlunoRelatorio";
import NomeBara from "./components/NomeBara/NomeBara";
import TabelaRelatorioAluno from "./components/TabelaRelatorioAluno/TabelaRelatorioAluno";
import TabelaRelatorioAlunoMobile from "./components/TabelaRelatorioAluno/TabelaRelatorioAlunoMobile2";
import TabelaRelatorioAlunoMobileSAT from "./components/TabelaRelatorioAluno/TabelaRelatorioAlunoMobileSAT";
import TabelaRelatorioAlunoSAT from "./components/TabelaRelatorioAluno/TabelaRelatorioAlunoSAT";

import styles from "./Relatorio.module.scss";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

export default function Relatorio() {
    const { entidade, id: turmaId } = useParams();

    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

    const [dynamicColumns, setDynamicColumns] = useState([]);
    const [dados, setDados] = useState([]);
    const [periodo, setPeriodo] = useState();
    const [periodos, setPeriodos] = useState([]);
    const [isSAT, setIsSAT] = useState(false);
    const [cursoId, setCursoId] = useState(undefined);
    const [num, setNum] = useState(1);

    const handlerClick = num => {
        const periodo = periodos[num - 1];

        setPeriodo(periodo);
        setNum(num);

        fetchDisciplinaAluno(periodo.dt_inicio, periodo.dt_fim);
    };

    const fetchDisciplinaAluno = async (dt_inicio, dt_fim) => {
        const url = `/api/area-aluno/disciplinas`;

        try {
            const response = await axios.get(url, {
                params: {
                    entidadeUrl: entidade,
                    code: turmaId,
                    dt_inicio,
                    dt_fim
                }
            });

            const dynamicColumns = [
                {
                    title: "Disciplinas",
                    dataIndex: "disciplinas",
                    key: "disciplinas",
                    align: "center"
                }
            ];

            response.data.colunas.forEach((coluna, index) => {
                dynamicColumns.push({
                    title: `${coluna}`,
                    dataIndex: `${coluna}_${index}`,
                    key: `${coluna}_${index}`,
                    align: "center"
                });
            });

            dynamicColumns.push({
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                align: "center"
            });

            setDynamicColumns(dynamicColumns);
            setDados(response.data.registos);
        } catch (error) {
            openNotificationWithIcon("Não foi possível carregar as avaliações");
        }
    };

    const listarPeriodos = () => {
        axios({
            method: "get",
            url: "/api/area-aluno/carregar-periodos",
            params: {
                code: turmaId
            }
        })
            .then(response => {
                const responsePeriodo = response.data.periodos;
                const responseIsSat = response.data.isSAT;
                setCursoId(response.data.cursoId);

                if (responsePeriodo.length > 0) {
                    setPeriodos(responsePeriodo);
                    setPeriodo(responsePeriodo[0]);
                    fetchDisciplinaAluno(responsePeriodo[0].dt_inicio, responsePeriodo[0].dt_fim);
                }
                setIsSAT(responseIsSat);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os periodos!");
            });
    };

    useEffect(() => {
        listarPeriodos();
    }, []);

    return (
        <div className={styles.relatorio}>
            <div className="background-layer" />
            <div className={styles.titulo}>
                <h1> ÁREA DO ALUNO</h1>
            </div>

            <BarraAreaAlunoRelatorio title={"RELATÓRIO"} code={turmaId} />

            <NomeBara
                num={num}
                nome={localStorage.getItem("nome")}
                handlerClick={handlerClick}
                total={periodos.length}
                periodo={periodo}
                isSAT={isSAT}
                cursoId={cursoId}
            ></NomeBara>

            {isTabletOrMobile ? (
                isSAT ? (
                    <TabelaRelatorioAlunoMobileSAT dynamicColumns={dynamicColumns} disciplinas={dados} />
                ) : (
                    <TabelaRelatorioAlunoMobile dynamicColumns={dynamicColumns} disciplinas={dados} />
                )
            ) : isSAT ? (
                <TabelaRelatorioAlunoSAT dynamicColumns={dynamicColumns} disciplinas={dados} />
            ) : (
                <TabelaRelatorioAluno dynamicColumns={dynamicColumns} disciplinas={dados} />
            )}
        </div>
    );
}
